// import React, { useEffect, useState } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Typography,
//   TextField,
//   InputLabel,
//   MenuItem,
//   FormControl,
//   Select,
//   Button,
//   Autocomplete,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
// } from "@mui/material";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import createInstance from "../../api/axiosinstance";
// import Toast from "../../utils/toast";
// import Loader from "../Loader";
// import { useSelector } from "react-redux";
// import COLORS from "../Themes/Colours";

// const CssFormControl = styled(FormControl)({
//   "& label": {
//     color: "#033538",
//     "&.Mui-focused": {
//       color: "#B9B9B9",
//     },
//   },
//   "& .MuiInputBase-root": {
//     color: "#033538",
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#033538",
//       borderRadius: 10,
//     },
//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#B9B9B9",
//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#B9B9B9",
//     },
//   },
// });

// const CssSelect = styled(Select)({
//   "& .MuiSvgIcon-root": {
//     color: "#033538",
//     textAlign: "center",
//   },
// });

// const CssTextField = styled(TextField)({
//   "& label.Mui-focused": {
//     color: "#033538",
//   },
//   "& label": {
//     color: "#033538",
//   },
//   "& .MuiInput-underline:after": {
//     borderBottomColor: "#B9B9B9",
//   },
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderColor: "#033538",
//       borderRadius: 10,
//     },
//     "&:hover fieldset": {
//       borderColor: "#B9B9B9",
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: "#B9B9B9",
//     },
//     "& .MuiInputBase-input": {
//       color: "#033538",
//     },
//   },
// });

// const ScheduleInterview = ({ onClose, onSchedule }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const [candidateId, setCandidateId] = useState("");
//   const [candidates, setCandidates] = useState([]);
//   const [candidateName, setCandidateName] = useState("");
//   const [jobs, setJobs] = useState([]);
//   const [jobTitle, setJobTitle] = useState("");
//   const [jobId, setJobId] = useState("");
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [meetingLink, setMeetingLink] = useState("");
//   const [meetingId, setMeetingId] = useState("");
//   const [round, setRound] = useState("");
//   const [keyNotes, setKeyNotes] = useState("");
//   const [interviewer, setInterviewer] = useState("");
//   const [interviewerList, setInterviewerList] = useState([]);
//   const [technologists, setTechnologists] = useState([]);
//   const [managers, setManagers] = useState([]);
//   const [hrs, setHrs] = useState([]);
//   const [interviewDuration, setInterviewDuration] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [initialLoading, setInitialLoading] = useState(true);
//   const [isGeneratingZoom, setIsGeneratingZoom] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [tpInterviewers, setTpInterviewers] = useState([]);
//   const [selectedTpInterviewer, setSelectedTpInterviewer] = useState("");
//   const [selectInterviewer, setSelectInterviewer] = useState("");
//   const { user } = useSelector((state) => state.auth);
//   const organizationId =
//     user?.organizationId || window.sessionStorage.getItem("organizationId");
//   const hrId = user?.orgUserId;

//   useEffect(() => {
//     if (candidateId) {
//       const candidate = candidates.find(
//         (candidate) => candidate.candidate_id === candidateId
//       );
//       if (candidate) {
//         setCandidateName(candidate.candidate_full_name);
//         setJobTitle(candidate.job_title);
//         setJobId(candidate.job_id);
//       } else {
//         setCandidateName("");
//         setJobTitle("");
//         setJobId("");
//       }
//     } else {
//       setCandidateName("");
//       setJobTitle("");
//       setJobId("");
//     }
//   }, [candidateId, candidates]);

//   useEffect(() => {
//     if (round) {
//       if (round === "Technical Round 1" || round === "Technical Round 2") {
//         setInterviewerList(technologists);
//       } else if (round === "Managerial") {
//         setInterviewerList(managers);
//       } else if (round === "HR") {
//         setInterviewerList(hrs);
//       } else if (round === "Third Party Interviewer") {
//         setInterviewerList([]); // hide internal interviewer table
//       }
//     } else {
//       setInterviewerList([]);
//     }

//     // reset both selections
//     setInterviewer("");
//     setSelectedTpInterviewer("");
//     setPage(0);
//   }, [round, technologists, managers, hrs]);

//   useEffect(() => {
//     const loadInitialData = async () => {
//       setInitialLoading(true);
//       try {
//         await Promise.all([
//           getAllCandidates(),
//           getAllJobs(),
//           getInterviewers(),
//           getAllTpInterviewers(),
//         ]);
//       } catch (error) {
//         console.error("Error loading initial data:", error);
//         Toast.error("Failed to load initial data. Please refresh the page.");
//       } finally {
//         setInitialLoading(false);
//       }
//     };

//     loadInitialData();
//   }, []);

//   // Auto-generate Zoom link when date and time are selected
//   useEffect(() => {
//     const generateZoomLink = async () => {
//       if (selectedDate && selectedTime) {
//         setIsGeneratingZoom(true);
//         try {
//           const formattedDate = `${selectedDate.getFullYear()}-${String(
//             selectedDate.getMonth() + 1
//           ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(
//             2,
//             "0"
//           )}`;

//           const formattedTime = `${String(selectedTime.getHours()).padStart(
//             2,
//             "0"
//           )}:${String(selectedTime.getMinutes()).padStart(2, "0")}`;

//           const response = await aiDishaApi.post("/zoom-meeting-creator/", {
//             date: formattedDate,
//             time: formattedTime,
//           });

//           setMeetingLink(response.data["Join URL"]);
//           setMeetingId(String(response.data["Meeting ID"]));
//           Toast.success("Zoom meeting link generated successfully");
//         } catch (error) {
//           console.error("Error generating Zoom link:", error);
//           Toast.error("Failed to generate Zoom meeting link");
//           setMeetingLink("");
//           setMeetingId("");
//         } finally {
//           setIsGeneratingZoom(false);
//         }
//       } else {
//         // Clear meeting link and ID if date/time is cleared
//         setMeetingLink("");
//         setMeetingId("");
//       }
//     };

//     generateZoomLink();
//   }, [selectedDate, selectedTime]);

//   const getAllCandidates = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/get-candidates-by-org-id/?org_id=${organizationId}`
//       );
//       setCandidates(response.data["candidates"] || []);
//       return response;
//     } catch (error) {
//       console.error("Error fetching list of candidates", error);
//       throw error;
//     }
//   };

//   const getAllJobs = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/all_active_jobs?org_id=${organizationId}`
//       );
//       setJobs(response.data || []);
//       return response;
//     } catch (error) {
//       console.error("Error fetching list of jobs", error);
//       throw error;
//     }
//   };

//   const getInterviewers = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/get_interviewers?org_id=${organizationId}`
//       );
//       const interviewers = response.data;
//       console.log("resppp", response);
//       setTechnologists(interviewers["Technical"] || []);
//       setHrs(interviewers["HR"] || []);
//       setManagers(interviewers["Managerial"] || []);
//       return response;
//     } catch (error) {
//       console.error("Error fetching interviewers", error);
//       throw error;
//     }
//   };

//   // Fetch all TP Interviewers
//   const getAllTpInterviewers = async () => {
//     try {
//       const response = await aiDishaApi.get("/get-all-interviewer");
//       const users = response.data["active_users"] || [];
//       setTpInterviewers(users.filter((u) => u.role === "TP-Interviewer"));
//       console.log("daaaa", response);
//     } catch (error) {
//       console.error("Error fetching TP interviewers:", error);
//       Toast.error("Failed to fetch TP Interviewers. Please try again.");
//     }
//   };

//   const validateForm = () => {
//     if (!hrId) {
//       Toast.error("HR ID is missing. Please log in again.");
//       return false;
//     }
//     if (!candidateId.trim()) {
//       Toast.error("Candidate ID cannot be empty");
//       return false;
//     }
//     if (!candidateName.trim()) {
//       Toast.error("Candidate Name cannot be empty");
//       return false;
//     }
//     if (!jobTitle.trim()) {
//       Toast.error("Job Title cannot be empty");
//       return false;
//     }
//     if (!round.trim()) {
//       Toast.error("Round cannot be empty");
//       return false;
//     }
//     if (!selectInterviewer.trim()) {
//       Toast.error("Select Interviewer Type cannot be empty");
//       return false;
//     }
//     if (!keyNotes.trim()) {
//       Toast.error("Key notes cannot be empty");
//       return false;
//     }

//     // ✅ Dynamic interviewer validation
//     if (selectInterviewer === "Third Party Interviewer") {
//       if (!selectedTpInterviewer.trim()) {
//         Toast.error("Please select a Third Party Interviewer");
//         return false;
//       }
//     } else {
//       if (!interviewer.trim()) {
//         Toast.error("Please select an Interviewer");
//         return false;
//       }
//     }

//     if (!selectedDate || !selectedTime) {
//       Toast.error("Interview Date and Time cannot be empty");
//       return false;
//     }
//     if (!meetingLink.trim()) {
//       Toast.error(
//         "Meeting Link cannot be empty. Please select date and time first."
//       );
//       return false;
//     }
//     if (!meetingId.trim()) {
//       Toast.error(
//         "Meeting ID cannot be empty. Please select date and time first."
//       );
//       return false;
//     }
//     if (
//       !interviewDuration.trim() ||
//       isNaN(interviewDuration) ||
//       interviewDuration <= 0
//     ) {
//       Toast.error("Please enter a valid interview duration in minutes");
//       return false;
//     }

//     return true;
//   };

//   const saveInterviewDetails = async (event) => {
//     event.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const combinedDateTime = new Date(
//         selectedDate.getFullYear(),
//         selectedDate.getMonth(),
//         selectedDate.getDate(),
//         selectedTime.getHours(),
//         selectedTime.getMinutes(),
//         selectedTime.getSeconds()
//       );

//       const now = new Date();
//       if (combinedDateTime <= now) {
//         Toast.error("Please select a future date and time");
//         setIsLoading(false);
//         return;
//       }

//       // FIXED: Keep user's selected time as-is (no UTC conversion)
//       const pad = (num) => String(num).padStart(2, "0");
//       const formattedDateTime = `${selectedDate.getFullYear()}-${pad(
//         selectedDate.getMonth() + 1
//       )}-${pad(selectedDate.getDate())}T${pad(selectedTime.getHours())}:${pad(
//         selectedTime.getMinutes()
//       )}:${pad(selectedTime.getSeconds())}.000000+00:00`;

//       console.log(
//         "Selected IST Time:",
//         combinedDateTime.toLocaleString("en-US", {
//           year: "numeric",
//           month: "2-digit",
//           day: "2-digit",
//           hour: "2-digit",
//           minute: "2-digit",
//           hour12: false,
//         })
//       );
//       console.log("Sent UTC Time:", formattedDateTime);

//       const selectedPanel =
//         selectInterviewer === "Third Party Interviewer"
//           ? selectedTpInterviewer
//           : interviewer;

//       const params = new URLSearchParams({
//         organization_id: organizationId,
//         Hr_id: hrId,
//         candidate_id: candidateId,
//         candidate_name: candidateName,
//         job_title: jobTitle,
//         Interview_panel: selectedPanel, // ✅ dynamic — user_id or panelist_id
//         select_interviewer: selectInterviewer,
//         link: meetingLink,
//         zoom_meeting_id: meetingId,
//         round: round,
//         Key_notes: keyNotes,
//         interview_date_and_time: formattedDateTime,
//         interview_duration: interviewDuration,
//       });

//       const response = await aiDishaApi.post(
//         "/schedule_interview",
//         {},
//         {
//           params,
//           paramsSerializer: {
//             indexes: null,
//           },
//         }
//       );

//       console.log("Interview details:", response.data);
//       clearForm();
//       Toast.success("Interview scheduled successfully");
//       if (onSchedule) onSchedule();
//       if (onClose) onClose();
//     } catch (error) {
//       console.error("Error scheduling interview:", error);
//       Toast.error(
//         "Failed to schedule interview: " + (error.message || "Unknown error")
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const clearForm = () => {
//     setCandidateId("");
//     setCandidateName("");
//     setJobTitle("");
//     setJobId("");
//     setMeetingLink("");
//     setMeetingId("");
//     setRound("");
//     setKeyNotes("");
//     setInterviewer("");
//     setSelectedDate(null);
//     setSelectedTime(null);
//     setInterviewDuration("");
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleSelectInterviewer = (panelist_id) => {
//     setInterviewer(panelist_id);
//   };

//   if (initialLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100%",
//         }}
//       >
//         <Loader />
//       </div>
//     );
//   }
//   const getMinTime = () => {
//     if (!selectedDate) return null;

//     const now = new Date();
//     const isToday = selectedDate.toDateString() === now.toDateString();

//     if (!isToday) {
//       // Allow full day for future dates
//       return new Date(
//         selectedDate.getFullYear(),
//         selectedDate.getMonth(),
//         selectedDate.getDate(),
//         0,
//         0
//       );
//     }

//     // For today → allow only future time
//     return now;
//   };

//   const getMaxTime = () => {
//     if (!selectedDate) return null;

//     return new Date(
//       selectedDate.getFullYear(),
//       selectedDate.getMonth(),
//       selectedDate.getDate(),
//       23,
//       45
//     );
//   };

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         overflowX: "hidden",
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//         scrollbarColor: "transparent transparent",
//       }}
//     >
//       {(isLoading || isGeneratingZoom) && (
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(255, 255, 255, 0.7)",
//             zIndex: 1000,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <Loader />
//         </div>
//       )}

//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 1%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
//           >
//             Schedule Online Interview
//           </Typography>
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Candidate ID
//           </Typography>
//           <CssFormControl sx={{ width: "90%", color: "#033538" }}>
//             <Autocomplete
//               options={candidates}
//               getOptionLabel={(option) =>
//                 `${option.candidate_id} - ${option.candidate_full_name}`
//               }
//               onChange={(e, value) =>
//                 setCandidateId(value ? value.candidate_id : "")
//               }
//               renderInput={(params) => (
//                 <CssTextField
//                   {...params}
//                   label="Search by ID or Name"
//                   size="small"
//                   sx={{ width: "95%", color: "black" }}
//                 />
//               )}
//               value={
//                 candidates.find((c) => c.candidate_id === candidateId) || null
//               }
//               sx={{
//                 width: "90%",
//                 "& .MuiAutocomplete-option": {
//                   color: "black !important",
//                 },
//                 "& .MuiAutocomplete-paper": {
//                   color: "black !important",
//                 },
//                 "& .MuiAutocomplete-listbox": {
//                   color: "black !important",
//                 },
//               }}
//               slotProps={{
//                 popper: {
//                   sx: {
//                     "& .MuiAutocomplete-paper": {
//                       color: "black !important",
//                     },
//                     "& .MuiAutocomplete-listbox": {
//                       color: "black !important",
//                     },
//                     "& .MuiAutocomplete-option": {
//                       color: "black !important",
//                     },
//                   },
//                 },
//               }}
//             />
//           </CssFormControl>
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Candidate Name
//           </Typography>
//           <CssTextField
//             value={candidateName}
//             size="small"
//             sx={{ width: "95%" }}
//             InputProps={{ readOnly: true }}
//           />
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Job Title
//           </Typography>
//           <CssTextField
//             value={jobTitle + (jobId ? " (" + jobId + ")" : "")}
//             size="small"
//             sx={{ width: "95%" }}
//             InputProps={{ readOnly: true }}
//           />
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Round
//           </Typography>
//           <CssFormControl sx={{ width: "90%", color: "#033538" }}>
//             <InputLabel>Select Round</InputLabel>
//             <CssSelect
//               label="Select Round"
//               value={round}
//               onChange={(e) => setRound(e.target.value)}
//               size="small"
//               sx={{
//                 width: "105%",
//                 textAlign: "center",
//                 color: "#033538",
//                 "& .MuiSelect-select": {
//                   color: "#033538",
//                 },
//               }}
//               required={true}
//             >
//               <MenuItem value="" disabled sx={{ color: "black" }}>
//                 Select Round
//               </MenuItem>
//               <MenuItem
//                 key="Technical Round 1"
//                 value="Technical Round 1"
//                 sx={{ color: "black" }}
//               >
//                 Technical Round 1
//               </MenuItem>
//               <MenuItem
//                 key="Technical Round 2"
//                 value="Technical Round 2"
//                 sx={{ color: "black" }}
//               >
//                 Technical Round 2
//               </MenuItem>
//               <MenuItem
//                 key="Managerial"
//                 value="Managerial"
//                 sx={{ color: "black" }}
//               >
//                 Managerial
//               </MenuItem>
//               <MenuItem key="HR" value="HR" sx={{ color: "black" }}>
//                 HR
//               </MenuItem>
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Select Interviewer Type
//           </Typography>
//           <CssFormControl sx={{ width: "90%", color: "#033538" }}>
//             <InputLabel>Select Interviewer</InputLabel>
//             <CssSelect
//               label="Select Interviewer"
//               value={selectInterviewer}
//               onChange={(e) => setSelectInterviewer(e.target.value)}
//               size="small"
//               sx={{
//                 width: "105%",
//                 textAlign: "center",
//                 color: "#033538",
//                 "& .MuiSelect-select": {
//                   color: "#033538",
//                 },
//               }}
//               required
//             >
//               <MenuItem sx={{ color: "black" }} value="" disabled>
//                 Select Interviewer
//               </MenuItem>
//               <MenuItem sx={{ color: "black" }} value="Company Interviewers">
//                 Company Interviewers
//               </MenuItem>
//               <MenuItem sx={{ color: "black" }} value="Third Party Interviewer">
//                 Third Party Interviewer
//               </MenuItem>
//             </CssSelect>
//           </CssFormControl>
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Key Notes
//           </Typography>
//           <CssTextField
//             label="Key Notes"
//             required
//             value={keyNotes}
//             size="small"
//             sx={{ width: "95%", color: "#033538" }}
//             onChange={(e) => setKeyNotes(e.target.value)}
//           />
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Interview Duration (minutes)
//           </Typography>
//           <CssTextField
//             label="Enter Duration"
//             value={interviewDuration}
//             size="small"
//             sx={{ width: "95%" }}
//             onChange={(e) => setInterviewDuration(e.target.value)}
//             type="number"
//           />
//         </Box>
//       </Box>

//       {/* DATE AND TIME SECTION - MOVED BEFORE MEETING LINK */}
//       <Box
//         gridColumn="span 12"
//         sx={{
//           marginTop: "25px",
//           marginBottom: "15px",
//           textAlign: "left",
//           marginLeft: "15px",
//         }}
//       >
//         <Typography
//           sx={{ fontFamily: "poppins", fontSize: "20px", color: "#033538" }}
//         >
//           Interview Date and Time
//         </Typography>
//       </Box>

//       <div
//         style={{
//           padding: "20px",
//           maxWidth: "400px",
//           margin: "0",
//           border: "1px solid #033538",
//           borderRadius: "10px",
//           position: "relative",
//           left: "1%",
//           marginTop: "5px",
//         }}
//       >
//         <div style={{ marginBottom: "20px", color: "#033538" }}>
//           <label style={{ color: "#033538" }}>Date: </label>
//           <DatePicker
//             className="custom-datepicker"
//             selected={selectedDate}
//             onChange={(date) => setSelectedDate(date)}
//             dateFormat="yyyy/MM/dd"
//             placeholderText="Select a date"
//             minDate={new Date()}
//           />
//         </div>
//         <div style={{ marginBottom: "20px" }}>
//           <label style={{ color: "#033538" }}>Time: </label>
//           <DatePicker
//             className="custom-datepicker"
//             selected={selectedTime}
//             onChange={(time) => setSelectedTime(time)}
//             showTimeSelect
//             showTimeSelectOnly
//             timeIntervals={15}
//             timeCaption="Time"
//             timeFormat="HH:mm"
//             dateFormat="HH:mm"
//             placeholderText="Select a time"
//             minTime={getMinTime()}
//             maxTime={getMaxTime()}
//           />
//         </div>
//         {selectedDate && selectedTime && (
//           <div style={{ color: "#033538", fontSize: "14px" }}>
//             <p>
//               Selected Interview Time (IST):{" "}
//               {new Date(
//                 selectedDate.getFullYear(),
//                 selectedDate.getMonth(),
//                 selectedDate.getDate(),
//                 selectedTime.getHours(),
//                 selectedTime.getMinutes(),
//                 selectedTime.getSeconds()
//               ).toLocaleString("en-US", {
//                 year: "numeric",
//                 month: "2-digit",
//                 day: "2-digit",
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 hour12: false,
//               })}
//             </p>
//             <p style={{ color: "#28a745", fontWeight: "bold" }}>
//               ✓ Time will be preserved exactly as selected
//             </p>
//           </div>
//         )}
//         {isGeneratingZoom && (
//           <p style={{ color: "#007bff", fontSize: "14px", marginTop: "10px" }}>
//             🔄 Generating Zoom meeting link...
//           </p>
//         )}
//       </div>

//       {/* MEETING LINK AND ID - NOW AFTER DATE/TIME */}
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "20px",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 1%",
//         }}
//       >
//         <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Meeting Link
//           </Typography>
//           <CssTextField
//             label="Zoom Meeting Link (Auto-generated)"
//             value={meetingLink}
//             size="small"
//             sx={{ width: "95%" }}
//             InputProps={{ readOnly: true }}
//           />
//         </Box>

//         <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
//           <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
//             Meeting ID
//           </Typography>
//           <CssTextField
//             label="Zoom Meeting ID (Auto-generated)"
//             value={meetingId}
//             size="small"
//             sx={{ width: "95%" }}
//             InputProps={{ readOnly: true }}
//           />
//         </Box>

//         {/* INTERVIEWER TABLES */}
//         <Box gridColumn="span 12" sx={{ marginTop: "25px", textAlign: "left" }}>
//           {selectInterviewer === "Third Party Interviewer" ? (
//             <>
//               <Typography
//                 sx={{
//                   fontFamily: "poppins",
//                   color: "#033538",
//                   fontSize: "20px",
//                 }}
//               >
//                 Select Third Party Interviewer
//               </Typography>
//               <TableContainer
//                 component={Paper}
//                 sx={{
//                   marginTop: "10px",
//                   borderRadius: "10px",
//                   maxHeight: "300px",
//                   overflow: "auto",
//                 }}
//               >
//                 <Table size="small">
//                   <TableHead sx={{ backgroundColor: "#033538" }}>
//                     <TableRow>
//                       <TableCell sx={{ color: "white" }}>Name</TableCell>
//                       <TableCell sx={{ color: "white" }}>Email</TableCell>
//                       <TableCell sx={{ color: "white" }}>Mobile</TableCell>
//                       <TableCell sx={{ color: "white" }}>Status</TableCell>
//                       <TableCell sx={{ color: "white" }}>Action</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tpInterviewers.map((tp) => (
//                       <TableRow
//                         key={tp.user_id}
//                         sx={{ backgroundColor: "#006A71" }}
//                       >
//                         <TableCell
//                           sx={{ color: "white", border: "1px solid black" }}
//                         >
//                           {tp.name}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: "white", border: "1px solid black" }}
//                         >
//                           {tp.email}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: "white", border: "1px solid black" }}
//                         >
//                           {tp.mobile}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: "white", border: "1px solid black" }}
//                         >
//                           {tp.activation_status}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: "white", border: "1px solid black" }}
//                         >
//                           <Button
//                             variant="contained"
//                             size="small"
//                             onClick={() => setSelectedTpInterviewer(tp.user_id)}
//                             sx={{
//                               backgroundColor: "#033538",
//                               color: "white",
//                               "&:hover": { backgroundColor: "#02484b" },
//                               fontFamily: "Poppins",
//                               textTransform: "none",
//                             }}
//                           >
//                             Select
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               {selectedTpInterviewer && (
//                 <Typography
//                   sx={{ fontFamily: "poppins", color: "#033538", mt: 1 }}
//                 >
//                   Selected TP Interviewer:{" "}
//                   {
//                     tpInterviewers.find(
//                       (i) => i.user_id === selectedTpInterviewer
//                     )?.name
//                   }{" "}
//                   ({selectedTpInterviewer})
//                 </Typography>
//               )}
//             </>
//           ) : (
//             <>
//               <Typography
//                 sx={{
//                   fontFamily: "poppins",
//                   color: "#033538",
//                   fontSize: "20px",
//                 }}
//               >
//                 Select Interviewer
//               </Typography>
//               <TableContainer
//                 component={Paper}
//                 sx={{
//                   marginTop: "10px",
//                   borderRadius: "10px",
//                   maxHeight: "300px",
//                   overflow: "auto",
//                 }}
//               >
//                 <Table size="small">
//                   <TableHead sx={{ backgroundColor: "#033538" }}>
//                     <TableRow>
//                       <TableCell sx={{ color: "white" }}>Name</TableCell>
//                       <TableCell sx={{ color: "white" }}>Email</TableCell>
//                       <TableCell sx={{ color: "white" }}>Skills</TableCell>
//                       <TableCell sx={{ color: "white" }}>Designation</TableCell>
//                       <TableCell sx={{ color: "white" }}>Action</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {interviewerList
//                       .slice(
//                         page * rowsPerPage,
//                         page * rowsPerPage + rowsPerPage
//                       )
//                       .map((interviewerItem) => (
//                         <TableRow
//                           key={interviewerItem.panelist_id}
//                           sx={{ backgroundColor: "#006A71" }}
//                         >
//                           <TableCell
//                             sx={{ color: "white", border: "1px solid black" }}
//                           >
//                             {interviewerItem.full_name}
//                           </TableCell>
//                           <TableCell
//                             sx={{ color: "white", border: "1px solid black" }}
//                           >
//                             {interviewerItem.official_email_id || "N/A"}
//                           </TableCell>
//                           <TableCell
//                             sx={{ color: "white", border: "1px solid black" }}
//                           >
//                             {Array.isArray(interviewerItem.skills)
//                               ? interviewerItem.skills.join(", ")
//                               : interviewerItem.skills || "N/A"}
//                           </TableCell>
//                           <TableCell
//                             sx={{ color: "white", border: "1px solid black" }}
//                           >
//                             {interviewerItem.designation || "N/A"}
//                           </TableCell>
//                           <TableCell
//                             sx={{ color: "white", border: "1px solid black" }}
//                           >
//                             <Button
//                               variant="contained"
//                               size="small"
//                               onClick={() =>
//                                 handleSelectInterviewer(
//                                   interviewerItem.panelist_id
//                                 )
//                               }
//                               sx={{
//                                 backgroundColor: "#033538",
//                                 color: "white",
//                                 "&:hover": { backgroundColor: "#02484b" },
//                                 fontFamily: "Poppins",
//                                 textTransform: "none",
//                               }}
//                             >
//                               Select
//                             </Button>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               {interviewer && (
//                 <Typography
//                   sx={{ fontFamily: "poppins", color: "#033538", mt: 1 }}
//                 >
//                   Selected Interviewer:{" "}
//                   {
//                     interviewerList.find((i) => i.panelist_id === interviewer)
//                       ?.full_name
//                   }{" "}
//                   ({interviewer})
//                 </Typography>
//               )}
//             </>
//           )}
//         </Box>
//       </Box>

//       <Box
//         gridColumn="span 12"
//         sx={{ marginTop: "30px", textAlign: "right", width: "90%" }}
//       >
//         <Button
//           type="button"
//           className="btn btn-sm rounded-2 fw-medium"
//           onClick={clearForm}
//           disabled={isLoading || isGeneratingZoom}
//           sx={{
//             border: "1px solid",
//             color: "#033538",
//             width: "120px",
//             height: "35px",
//             borderRadius: "10px",
//             marginRight: "4%",
//           }}
//         >
//           Clear
//         </Button>

//         <Button
//           type="submit"
//           className="btn btn-sm rounded-2 fw-medium"
//           disabled={isLoading || isGeneratingZoom}
//           sx={{
//             border: "1px solid",
//             color: "white",
//             width: "120px",
//             height: "35px",
//             borderRadius: "10px",
//             backgroundColor: "#006A71",
//             "&:hover": {
//               backgroundColor: "#033538",
//             },
//           }}
//           onClick={(e) => saveInterviewDetails(e)}
//         >
//           Submit
//         </Button>
//       </Box>

//       <br />
//       <br />
//       <br />
//     </div>
//   );
// };

// export default ScheduleInterview;






























































import React, { useEffect, useState} from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import createInstance from "../../api/axiosinstance";
import Toast from "../../utils/toast";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import { useThemeMode } from "../Themes/ThemeContextTemp.js";
const ScheduleInterview = ({ onClose, onSchedule }) => {
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();

  // State Management
  const [candidateId, setCandidateId] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [candidateName, setCandidateName] = useState("");
  const [jobs, setJobs] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [jobId, setJobId] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [meetingLink, setMeetingLink] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [round, setRound] = useState("");
  const [keyNotes, setKeyNotes] = useState("");
  const [interviewer, setInterviewer] = useState([]);
  const [interviewerList, setInterviewerList] = useState([]);
  const [technologists, setTechnologists] = useState([]);
  const [managers, setManagers] = useState([]);
  const [hrs, setHrs] = useState([]);
  const [interviewDuration, setInterviewDuration] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isGeneratingZoom, setIsGeneratingZoom] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tpInterviewers, setTpInterviewers] = useState([]);
  const [selectedTpInterviewer, setSelectedTpInterviewer] = useState([]);
  const [selectInterviewer, setSelectInterviewer] = useState("");
  const [ccEmails, setCcEmails] = useState([]);

  const { user } = useSelector((state) => state.auth);
  const organizationId =
    user?.organizationId || window.sessionStorage.getItem("organizationId");
  const hrId = user?.orgUserId;

  // Create styled components inside component with access to COLORS
  const CssFormControl = styled(FormControl)({
    "& label": {
      color: COLORS.text,
      "&.Mui-focused": {
        color: COLORS.text,
      },
    },
    "& .MuiInputBase-root": {
      color: COLORS.text,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
        borderRadius: 10,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: COLORS.border,
      },
    },
  });

  const CssSelect = styled(Select)({
    "& .MuiSvgIcon-root": {
      color: COLORS.text,
      textAlign: "center",
    },
  });

  const CssTextField = styled(TextField)({
    "& label": {
      color: COLORS.text,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: COLORS.border,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: COLORS.border,
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: COLORS.border,
      },
      "&.Mui-focused fieldset": {
        borderColor: COLORS.border,
      },
      "& .MuiInputBase-input": {
        color: COLORS.text,
      },
    },
  });

  useEffect(() => {
    if (candidateId) {
      const candidate = candidates.find(
        (candidate) => candidate.candidate_id === candidateId
      );
      if (candidate) {
        setCandidateName(candidate.candidate_full_name);
        setJobTitle(candidate.job_title);
        setJobId(candidate.job_id);
      } else {
        setCandidateName("");
        setJobTitle("");
        setJobId("");
      }
    } else {
      setCandidateName("");
      setJobTitle("");
      setJobId("");
    }
  }, [candidateId, candidates]);

  useEffect(() => {
    if (round) {
      if (round === "Technical Round 1" || round === "Technical Round 2") {
        setInterviewerList(technologists);
      } else if (round === "Managerial") {
        setInterviewerList(managers);
      } else if (round === "HR") {
        setInterviewerList(hrs);
      } else if (round === "Third Party Interviewer") {
        setInterviewerList([]);
      }
    } else {
      setInterviewerList([]);
    }

    setInterviewer([]);
    setSelectedTpInterviewer([]);
    setPage(0);
  }, [round, technologists, managers, hrs]);

  useEffect(() => {
    const loadInitialData = async () => {
      setInitialLoading(true);
      try {
        await Promise.all([
          getAllCandidates(),
          getAllJobs(),
          getInterviewers(),
          getAllTpInterviewers(),
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
        Toast.error("Failed to load initial data. Please refresh the page.");
      } finally {
        setInitialLoading(false);
      }
    };

    loadInitialData();
  }, []);

  useEffect(() => {
    const generateZoomLink = async () => {
      if (selectedDate && selectedTime) {
        setIsGeneratingZoom(true);
        try {
          const formattedDate = `${selectedDate.getFullYear()}-${String(
            selectedDate.getMonth() + 1
          ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(
            2,
            "0"
          )}`;

          const formattedTime = `${String(selectedTime.getHours()).padStart(
            2,
            "0"
          )}:${String(selectedTime.getMinutes()).padStart(2, "0")}`;

          const response = await aiDishaApi.post("/zoom-meeting-creator/", {
            date: formattedDate,
            time: formattedTime,
          });

          setMeetingLink(response.data["Join URL"]);
          setMeetingId(String(response.data["Meeting ID"]));
          Toast.success("Zoom meeting link generated successfully");
        } catch (error) {
          console.error("Error generating Zoom link:", error);
          Toast.error("Failed to generate Zoom meeting link");
          setMeetingLink("");
          setMeetingId("");
        } finally {
          setIsGeneratingZoom(false);
        }
      } else {
        setMeetingLink("");
        setMeetingId("");
      }
    };

    generateZoomLink();
  }, [selectedDate, selectedTime]);

  const getAllCandidates = async () => {
    try {
      const response = await aiDishaApi.get(
        `/get-candidates-by-org-id/?org_id=${organizationId}`
      );
      setCandidates(response.data["candidates"] || []);
      return response;
    } catch (error) {
      console.error("Error fetching list of candidates", error);
      throw error;
    }
  };

  const getAllJobs = async () => {
    try {
      const response = await aiDishaApi.get(
        `/all_active_jobs?org_id=${organizationId}`
      );
      setJobs(response.data || []);
      return response;
    } catch (error) {
      console.error("Error fetching list of jobs", error);
      throw error;
    }
  };

  const getInterviewers = async () => {
    try {
      const response = await aiDishaApi.get(
        `/get_interviewers?org_id=${organizationId}`
      );
      const interviewers = response.data;
      console.log("resppp", response);
      setTechnologists(interviewers["Technical"] || []);
      setHrs(interviewers["HR"] || []);
      setManagers(interviewers["Managerial"] || []);
      return response;
    } catch (error) {
      console.error("Error fetching interviewers", error);
      throw error;
    }
  };

  const getAllTpInterviewers = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-interviewer");
      const users = response.data["active_users"] || [];
      setTpInterviewers(users.filter((u) => u.role === "TP-Interviewer"));
      console.log("daaaa", response);
    } catch (error) {
      console.error("Error fetching TP interviewers:", error);
      Toast.error("Failed to fetch TP Interviewers. Please try again.");
    }
  };



const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

for (let email of ccEmails) {
  if (!isValidEmail(email)) {
    Toast.error(`Invalid email: ${email}`);
    return;
  }
}



  const validateForm = () => {
    if (!hrId) {
      Toast.error("HR ID is missing. Please log in again.");
      return false;
    }
    if (!candidateId.trim()) {
      Toast.error("Candidate ID cannot be empty");
      return false;
    }
    if (!candidateName.trim()) {
      Toast.error("Candidate Name cannot be empty");
      return false;
    }
    if (!jobTitle.trim()) {
      Toast.error("Job Title cannot be empty");
      return false;
    }
    if (!round.trim()) {
      Toast.error("Round cannot be empty");
      return false;
    }
    if (!selectInterviewer) {
      Toast.error("Select Interviewer Type cannot be empty");
      return false;
    }
    if (!keyNotes.trim()) {
      Toast.error("Key notes cannot be empty");
      return false;
    }

    if (selectInterviewer === "Third Party Interviewer") {
      if (selectedTpInterviewer.length === 0) {
        Toast.error("Please select at least one Third Party Interviewer");
        return false;
      }
    } else {
      if (interviewer.length === 0) {
        Toast.error("Please select at least one Interviewer");
        return false;
      }
    }

    if (!selectedDate || !selectedTime) {
      Toast.error("Interview Date and Time cannot be empty");
      return false;
    }
    if (!meetingLink.trim()) {
      Toast.error(
        "Meeting Link cannot be empty. Please select date and time first."
      );
      return false;
    }
    if (!meetingId.trim()) {
      Toast.error(
        "Meeting ID cannot be empty. Please select date and time first."
      );
      return false;
    }
    if (
      !interviewDuration.trim() ||
      isNaN(interviewDuration) ||
      interviewDuration <= 0
    ) {
      Toast.error("Please enter a valid interview duration in minutes");
      return false;
    }

    return true;
  };

  const saveInterviewDetails = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const combinedDateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        selectedTime.getHours(),
        selectedTime.getMinutes(),
        selectedTime.getSeconds()
      );

      const now = new Date();
      if (combinedDateTime <= now) {
        Toast.error("Please select a future date and time");
        setIsLoading(false);
        return;
      }

      const pad = (num) => String(num).padStart(2, "0");
      const formattedDateTime = `${selectedDate.getFullYear()}-${pad(
        selectedDate.getMonth() + 1
      )}-${pad(selectedDate.getDate())}T${pad(selectedTime.getHours())}:${pad(
        selectedTime.getMinutes()
      )}:${pad(selectedTime.getSeconds())}.000000+00:00`;

      console.log(
        "Selected IST Time:",
        combinedDateTime.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })
      );
      console.log("Sent UTC Time:", formattedDateTime);

      const selectedPanel =
        selectInterviewer === "Third Party Interviewer"
          ? selectedTpInterviewer
          : interviewer;

      const params = new URLSearchParams();
       params.append("organization_id", organizationId);
       params.append("Hr_id", hrId);
       params.append("candidate_id", candidateId);
       params.append("candidate_name", candidateName);
       params.append("job_title", jobTitle);
       selectedPanel.forEach((id) => {
         params.append("Interview_panel", id);
       });
       params.append("select_interviewer", selectInterviewer);
       params.append("link", meetingLink);
       params.append("zoom_meeting_id", meetingId);
       params.append("round", round);
       params.append("Key_notes", keyNotes);
       params.append("interview_date_and_time", formattedDateTime);
       params.append("interview_duration", interviewDuration);

       ccEmails.forEach((email) => {
        params.append("cc_emails", email);
      });

       // DEBUG
       console.log("Final params string:", params.toString());

      const response = await aiDishaApi.post(
        `/schedule_interview?${params.toString()}`,
        {},  
      );
      console.log("Interview details:", response.data);
      clearForm();
      Toast.success("Interview scheduled successfully");
      if (onSchedule) onSchedule();
      if (onClose) onClose();
    } catch (error) {
      console.error("Error scheduling interview:", error);
      Toast.error(
        "Failed to schedule interview: " + (error.message || "Unknown error")
      );
    } finally {
      setIsLoading(false);
    }
  };

  const clearForm = () => {
    setCandidateId("");
    setCandidateName("");
    setJobTitle("");
    setJobId("");
    setMeetingLink("");
    setMeetingId("");
    setRound("");
    setKeyNotes("");
    setInterviewer([]);
    setSelectedTpInterviewer([]);
    setSelectedDate(null);
    setSelectedTime(null);
    setInterviewDuration("");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectInterviewer = (panelist_id) => {
    // setInterviewer(panelist_id);
     setInterviewer((prev) =>
    prev.includes(panelist_id)
      ? prev.filter((id) => id !== panelist_id)
      : [...prev, panelist_id]
  );
};


  if (initialLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Loader />
      </div>
    );
  }

  const getMinTime = () => {
    if (!selectedDate) return null;

    const now = new Date();
    const isToday = selectedDate.toDateString() === now.toDateString();

    if (!isToday) {
      return new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        0,
        0
      );
    }

    return now;
  };

  const getMaxTime = () => {
    if (!selectedDate) return null;

    return new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      23,
      45
    );
  };

  // Create dynamic DatePicker styles
  const datePickerStyles = `
    .react-datepicker-wrapper {
      width: 100%;
    }
    
    .react-datepicker__input-container input {
      background: ${COLORS.primary} !important;
      color: ${COLORS.text} !important;
      border: 1px solid ${COLORS.border} !important;
      border-radius: 8px !important;
      padding: 8px !important;
      font-family: poppins !important;
    }
    
    .react-datepicker__input-container input::placeholder {
      color: ${COLORS.textSecondary} !important;
    }
    
    .react-datepicker {
      background: ${COLORS.primary} !important;
      border: 1px solid ${COLORS.border} !important;
      border-radius: 8px !important;
      font-family: poppins !important;
    }
    
    .react-datepicker__header {
      background: ${COLORS.accent} !important;
      border-bottom: 1px solid ${COLORS.border} !important;
      border-radius: 8px 8px 0 0 !important;
    }
    
    .react-datepicker__header__text {
      color: white !important;
      font-weight: 600 !important;
    }
    
    .react-datepicker__current-month-label {
      color: white !important;
      font-weight: 600 !important;
    }
    
    .react-datepicker__navigation-icon::before {
      border-color: white !important;
    }
    
    .react-datepicker__day-names {
      border-top: 1px solid ${COLORS.border} !important;
    }
    
    .react-datepicker__day-name {
      color: ${COLORS.background} !important;
      font-weight: 600 !important;
    }
    
    .react-datepicker__day {
      color: ${COLORS.text} !important;
    }
    
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range {
      background-color: ${COLORS.accent} !important;
      color: white !important;
      font-weight: 600 !important;
    }
    
    .react-datepicker__day--today {
      font-weight: 600 !important;
      background-color: ${COLORS.hoverBg} !important;
      color: ${COLORS.text} !important;
    }
    
    .react-datepicker__day:hover {
      background-color: ${COLORS.hoverBg} !important;
      color: ${COLORS.text} !important;
    }
    
    .react-datepicker__time-container {
      border-left: 1px solid ${COLORS.border} !important;
    }
    
    .react-datepicker__time-box {
      background: ${COLORS.primary} !important;
    }
    
    .react-datepicker__time-list {
      background: ${COLORS.primary} !important;
    }
    
    .react-datepicker__time-list__item {
      color: ${COLORS.text} !important;
    }
    
    .react-datepicker__time-list__item--selected {
      background: ${COLORS.accent} !important;
      color: ${COLORS.background} !important;
      font-weight: 600 !important;
    }
    
    .react-datepicker__time-list__item:hover {
      background: ${COLORS.hoverBg} !important;
    }
  `;

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        scrollbarColor: "transparent transparent",
      }}
    >
      <style>{datePickerStyles}</style>
      {(isLoading || isGeneratingZoom) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      )}

      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 10%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{
              fontFamily: "poppins",
              fontSize: "28px",
              color: COLORS.text,
              mb: "2%",
            }}
          >
            Schedule Online Interview
          </Typography>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Candidate ID
          </Typography>
          <CssFormControl sx={{ width: "90%", color: COLORS.text }}>
            <Autocomplete
              options={candidates}
              getOptionLabel={(option) =>
                `${option.candidate_id} - ${option.candidate_full_name}`
              }
              onChange={(e, value) =>
                setCandidateId(value ? value.candidate_id : "")
              }
              renderInput={(params) => (
                <CssTextField
                  {...params}
                  label="Search by ID or Name"
                  size="small"
                  sx={{ width: "95%", color: "black", background: COLORS.primary }}
                />
              )}
              value={
                candidates.find((c) => c.candidate_id === candidateId) || null
              }
              sx={{
                width: "90%",
                "& .MuiAutocomplete-option": {
                  color: "black !important",
                },
                "& .MuiAutocomplete-paper": {
                  color: "black !important",
                },
                "& .MuiAutocomplete-listbox": {
                  color: "black !important",
                },
              }}
              slotProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-paper": {
                      color: "black !important",
                    },
                    "& .MuiAutocomplete-listbox": {
                      color: "black !important",
                    },
                    "& .MuiAutocomplete-option": {
                      color: "black !important",
                    },
                  },
                },
              }}
            />
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Candidate Name
          </Typography>
          <CssTextField
            value={candidateName}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Job Title
          </Typography>
          <CssTextField
            value={jobTitle + (jobId ? " (" + jobId + ")" : "")}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Round<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Round</InputLabel>
            <CssSelect
              label="Select Round"
              value={round}
              onChange={(e) => setRound(e.target.value)}
              size="small"
              sx={{
                width: "100%",
                textAlign: "center",
                background: COLORS.primary,
              }}
              required={true}
            >
              <MenuItem value="" disabled sx={{ color: "black" }}>
                Select Round
              </MenuItem>
              <MenuItem
                key="Technical Round 1"
                value="Technical Round 1"
                sx={{ color: "black" }}
              >
                Technical Round 1
              </MenuItem>
              <MenuItem
                key="Technical Round 2"
                value="Technical Round 2"
                sx={{ color: "black" }}
              >
                Technical Round 2
              </MenuItem>
              <MenuItem
                key="Managerial"
                value="Managerial"
                sx={{ color: "black" }}
              >
                Managerial
              </MenuItem>
              <MenuItem key="HR" value="HR" sx={{ color: "black" }}>
                HR
              </MenuItem>
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Select Interviewer Type<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Interviewer</InputLabel>
            <CssSelect
              label="Select Interviewer"
              value={selectInterviewer}
              onChange={(e) => setSelectInterviewer(e.target.value)}
              size="small"
              sx={{
                width: "100%",
                textAlign: "center",
                background: COLORS.primary,
              }}
              required
            >
              <MenuItem sx={{ color: "black" }} value="" disabled>
                Select Interviewer
              </MenuItem>
              <MenuItem sx={{ color: "black" }} value="Company Interviewers">
                Company Interviewers
              </MenuItem>
              <MenuItem sx={{ color: "black" }} value="Third Party Interviewer">
                Third Party Interviewer
              </MenuItem>
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Key Notes<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            label="Enter Key Notes"
            required
            value={keyNotes}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            onChange={(e) => setKeyNotes(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Interview Duration (minutes)<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            label="Enter Duration"
            value={interviewDuration}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            onChange={(e) => setInterviewDuration(e.target.value)}
            type="number"
          />
        </Box>
            <Box
              gridColumn="span 6"
              sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
                CC Emails (Optional)
              </Typography>
            
              <Autocomplete
                multiple
                freeSolo
                options={[]} // no predefined options
                value={ccEmails}
                onChange={(event, newValue) => setCcEmails(newValue)}
                renderInput={(params) => (
                  <CssTextField
                    {...params}
                    label="Enter CC emails and press Enter"
                    placeholder="example@gmail.com"
                    size="small"
                    sx={{ width: "95%", background: COLORS.primary }}
                  />
                )}
              />
            </Box>
      </Box>

      {/* DATE AND TIME SECTION */}
      <Box
        sx={{
          marginTop: "25px",
          marginBottom: "15px",
          textAlign: "left",
          marginLeft: "10%",
        }}
      >
        <Typography
          sx={{
            fontFamily: "poppins",
            fontSize: "20px",
            color: COLORS.text,
            fontWeight: 600,
          }}
        >
          Interview Date and Time
        </Typography>
      </Box>

      <div
        style={{
          padding: "20px",
          maxWidth: "500px",
          margin: "0 auto",
          marginLeft: "10%",
          border: `1px solid ${COLORS.border}`,
          borderRadius: "10px",
          backgroundColor: COLORS.primary,
          marginTop: "10px",
        }}
      >
        <div style={{ marginBottom: "20px", color: COLORS.text }}>
          <label style={{ color: COLORS.text, fontWeight: 500, marginBottom: "8px", display: "block" }}>Date: </label>
          <DatePicker
            className="custom-datepicker"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="yyyy/MM/dd"
            placeholderText="Select a date"
            minDate={new Date()}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ color: COLORS.text, fontWeight: 500, marginBottom: "8px", display: "block" }}>Time: </label>
          <DatePicker
            className="custom-datepicker"
            selected={selectedTime}
            onChange={(time) => setSelectedTime(time)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="HH:mm"
            placeholderText="Select a time"
            minTime={getMinTime()}
            maxTime={getMaxTime()}
            sx= {{background:COLORS.background}}
          />
        </div>
        {selectedDate && selectedTime && (
          <div style={{ color: COLORS.text, fontSize: "14px" }}>
            <p style={{ marginBottom: "8px" }}>
              Selected Interview Time (IST):{" "}
              {new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate(),
                selectedTime.getHours(),
                selectedTime.getMinutes(),
                selectedTime.getSeconds()
              ).toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </p>
            <p style={{ color: COLORS.accent, fontWeight: "bold" }}>
              ✓ Time will be preserved exactly as selected
            </p>
          </div>
        )}
        {isGeneratingZoom && (
          <p style={{ color: COLORS.accent, fontSize: "14px", marginTop: "10px" }}>
            🔄 Generating Zoom meeting link...
          </p>
        )}
      </div>

      {/* MEETING LINK AND ID */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "30px",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 10%",
        }}
      >
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Meeting Link
          </Typography>
          <CssTextField
            label="Zoom Meeting Link (Auto-generated)"
            value={meetingLink}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
            Meeting ID
          </Typography>
          <CssTextField
            label="Zoom Meeting ID (Auto-generated)"
            value={meetingId}
            size="small"
            sx={{ width: "95%", background: COLORS.primary }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* INTERVIEWER TABLES */}
        <Box gridColumn="span 12" sx={{ marginTop: "30px", textAlign: "left" }}>
          {selectInterviewer === "Third Party Interviewer" ? (
            <>
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: COLORS.text,
                  fontSize: "20px",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Select Third Party Interviewer
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  marginTop: "15px",
                  borderRadius: "10px",
                  maxHeight: "300px",
                  overflow: "auto",
                  background: COLORS.primary,
                }}
              >
                <Table size="small">
                  <TableHead sx={{ background: COLORS.accent }}>
                    <TableRow>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Email
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Mobile
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Status
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tpInterviewers.map((tp) => (
                      <TableRow
                        key={tp.user_id}
                        sx={{
                          backgroundColor: COLORS.primary,
                          "&:hover": { backgroundColor: COLORS.hoverBg },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: `1px solid ${COLORS.border}`,
                          }}
                        >
                          {tp.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: `1px solid ${COLORS.border}`,
                          }}
                        >
                          {tp.email}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: `1px solid ${COLORS.border}`,
                          }}
                        >
                          {tp.mobile}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: `1px solid ${COLORS.border}`,
                          }}
                        >
                          {tp.activation_status}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: `1px solid ${COLORS.border}`,
                          }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => setSelectedTpInterviewer((prev) => prev.includes(tp.user_id)? prev.filter((id) => id !== tp.user_id)  : [...prev, tp.user_id])}
                            sx={{
                              backgroundColor:
                                selectedTpInterviewer === tp.user_id
                                  ? COLORS.accent
                                  : COLORS.accent,
                              color: "white",
                              "&:hover": { backgroundColor: COLORS.accent },
                              fontFamily: "Poppins",
                              textTransform: "none",
                              fontWeight: selectedTpInterviewer === tp.user_id ? 600 : 500,
                            }}
                          >
                            {selectedTpInterviewer.includes(tp.user_id) ? "✓ Selected" : "Select"}
                            {/* {selectedTpInterviewer === tp.user_id
                              ? "Selected"
                              : "Select"} */}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {selectedTpInterviewer.length > 0 && (
                   <Typography
                     sx={{
                       fontFamily: "poppins",
                       color: COLORS.accent,
                       mt: 2,
                       fontWeight: 600,
                     }}
                   >
                     ✓ Selected TP Interviewers ({selectedTpInterviewer.length}):{" "}
                     {selectedTpInterviewer
                       .map((id) => tpInterviewers.find((i) => i.user_id === id)?.name)
                       .filter(Boolean)
                       .join(", ")}
                   </Typography>
                 )}
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontFamily: "poppins",
                  color: COLORS.text,
                  fontSize: "20px",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Select Interviewer
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  marginTop: "15px",
                  borderRadius: "10px",
                  maxHeight: "300px",
                  overflow: "auto",
                  backgroundColor: COLORS.primary,
                }}
              >
                <Table size="small">
                  <TableHead sx={{ backgroundColor: COLORS.accent }}>
                    <TableRow>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Email
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Skills
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Designation
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: 600 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {interviewerList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((interviewerItem) => (
                        <TableRow
                          key={interviewerItem.panelist_id}
                          sx={{
                            backgroundColor: COLORS.primary,
                            "&:hover": { backgroundColor: COLORS.hoverBg },
                          }}
                        >
                          <TableCell
                            sx={{
                              color: COLORS.text,
                              border: `1px solid ${COLORS.border}`,
                            }}
                          >
                            {interviewerItem.full_name}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: COLORS.text,
                              border: `1px solid ${COLORS.border}`,
                            }}
                          >
                            {interviewerItem.official_email_id || "N/A"}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: COLORS.text,
                              border: `1px solid ${COLORS.border}`,
                            }}
                          >
                            {Array.isArray(interviewerItem.skills)
                              ? interviewerItem.skills.join(", ")
                              : interviewerItem.skills || "N/A"}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: COLORS.text,
                              border: `1px solid ${COLORS.border}`,
                            }}
                          >
                            {interviewerItem.designation || "N/A"}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: COLORS.text,
                              border: `1px solid ${COLORS.border}`,
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() =>
                                handleSelectInterviewer(
                                  interviewerItem.panelist_id
                                )
                              }
                              sx={{
                                backgroundColor:
                                  interviewer === interviewerItem.panelist_id
                                    ? COLORS.accent
                                    : COLORS.accent,
                                color: "white",
                                "&:hover": { backgroundColor: COLORS.accent },
                                fontFamily: "Poppins",
                                textTransform: "none",
                                fontWeight:
                                  interviewer === interviewerItem.panelist_id
                                    ? 600
                                    : 500,
                              }}
                            >
                              {/* {interviewer === interviewerItem.panelist_id
                                ? "Selected"
                                : "Select"} */}
                                {interviewer.includes(interviewerItem.panelist_id) ? "✓ Selected" : "Select"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={interviewerList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ color: COLORS.text }}
              />

              {interviewer.length > 0 && (
               <Typography
                 sx={{
                   fontFamily: "poppins",
                   color: COLORS.accent,
                   mt: 2,
                   fontWeight: 600,
                 }}
               >
                 ✓ Selected Interviewers ({interviewer.length}):{" "}
                 {interviewer
                   .map((id) => interviewerList.find((i) => i.panelist_id === id)?.full_name)
                   .filter(Boolean)
                   .join(", ")}
               </Typography>
             )}
            </>
          )}
        </Box>
      </Box>

      <Box
        gridColumn="span 12"
        sx={{ marginTop: "30px", textAlign: "right", width: "85%", mr: "10%" }}
      >
        <Button
          type="button"
          className="btn btn-sm rounded-2 fw-medium"
          onClick={clearForm}
          disabled={isLoading || isGeneratingZoom}
          sx={{
            border: "1px solid",
            color: COLORS.button,
            "&:hover": {
              color: COLORS.hover_btn,
            },
            width: "120px",
            height: "35px",
            borderRadius: "10px",
            marginRight: "2%",
          }}
        >
          Clear
        </Button>

        <Button
          type="submit"
          className="btn btn-sm rounded-2 fw-medium"
          disabled={isLoading || isGeneratingZoom}
          sx={{
            background: COLORS.button,
            "&:hover": {
              background: COLORS.hover_btn,
            },
            color: COLORS.background,
            width: "120px",
            height: "35px",
            borderRadius: "10px",
          }}
          onClick={(e) => saveInterviewDetails(e)}
        >
          Submit
        </Button>
      </Box>

      <br />
      <br />
      <br />
    </div>
  );
};

export default ScheduleInterview;